import { produce } from "immer"
import { useSearchStore } from "../search/store"
import { initialTableSettings as amInitialSettings, propertyNames } from "../agentMovement";
import { modules } from "../../constants";

export const actions = (set, get) => ({
    getSelectedModule: () => useSearchStore.getState().selectedModule,
    setPropertyValue: (propertyName, value) => set(produce(state => {
        const module = state[get().getSelectedModule];
        module[propertyName] = value;
    }), false, 'setPropertyValue'),
    setSortColumn: (colId, sortDir) => get().setPropertyValue(propertyNames.defaultSort, { colId, sortDir }),
    setColumns: (colId, newstate) => set(produce(state => {
        const selectedModule = useSearchStore.getState().selectedModule;
        const module = state[selectedModule];
        const columns = module.columns.map(col => {
            if (col.id === colId || col?.boundMetricId === colId) {
                return { ...col, ...newstate };
            }
            return col;
        });
        module.columns = columns;
    }), false, 'setColumns'),
    resetTableSettings: () => set(produce(state => {
        const selectedModule = useSearchStore.getState().selectedModule;
        if (selectedModule === modules.proficiencyMetrics.agentMovement) {
            state[selectedModule] = amInitialSettings;
        }
    }), false, 'resetTableSettings'),
});
